import { BaseService } from '@/bundles/App/models/BaseService';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';
import {
  ILeaseIngestion,
  IListFilters,
  IUploadLeaseFormFields,
  IUploadLeaseResponse,
  IPatchExtractionRequest,
  IRejectLeaseRequest,
  IApproveLeaseRequest,
} from '@/bundles/LeaseIngestion/types';

const BASE_URL = '/lease-ingestion';

export default class LeaseIngestionService extends BaseService<ILeaseIngestion, RecordMapper<ILeaseIngestion>> {
  async list (filters: IListFilters = {}): Promise<ILeaseIngestion[]> {
    try {
      const response = await this.transport.get(BASE_URL, filters);
      const items: ILeaseIngestion[] = Array.isArray(response) ? response : (response?.data ?? []);

      return items.map((item) => this.recordMapper.mapToModel(item));
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async one (id: string): Promise<ILeaseIngestion> {
    try {
      const response = await this.transport.get(`${BASE_URL}/${id}`);

      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async upload (fields: IUploadLeaseFormFields): Promise<IUploadLeaseResponse> {
    try {
      const formData = new FormData();
      formData.append('lease', fields.lease, fields.lease.name);

      if (fields.abstract) {
        formData.append('abstract', fields.abstract, fields.abstract.name);
      }

      if (fields.label) {
        formData.append('label', fields.label);
      }

      if (fields.extraction_model) {
        formData.append('extraction_model', fields.extraction_model);
      }

      if (fields.enrich_property) {
        formData.append('enrich_property', 'true');
      }

      return await this.transport.post(BASE_URL, formData);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async patchExtraction (id: string, body: IPatchExtractionRequest): Promise<ILeaseIngestion> {
    try {
      const response = await this.transport.patch(`${BASE_URL}/${id}/extraction`, body);

      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async reject (id: string, body: IRejectLeaseRequest): Promise<ILeaseIngestion> {
    try {
      const response = await this.transport.post(`${BASE_URL}/${id}/reject`, body);

      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async approve (id: string, body: IApproveLeaseRequest): Promise<ILeaseIngestion> {
    try {
      const response = await this.transport.post(`${BASE_URL}/${id}/approve`, body);

      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
